export function isInteger(num: unknown): num is number {
	return Number.isInteger(num as number);
}
